var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRedialButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 109 109",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#FF7100",
    fill: "#FF7100",
    cx: 54.5,
    cy: 54.5,
    r: 51.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.317 45.897c-.294 2.431 1.404 4.655 3.822 4.936l9.618 1.233c2.418.281 4.642-1.438 4.937-3.868l1.286-9.668c.295-2.43-1.404-4.654-3.822-4.936-1.935-.17-3.774.794-4.547 2.573a27.744 27.744 0 00-8.377-6.577 27.345 27.345 0 00-21.02-1.61c-6.965 2.292-12.721 7.237-16.073 13.815-3.351 6.578-3.97 14.141-1.73 21.123a27.345 27.345 0 0013.658 16.06 27.345 27.345 0 0021.02 1.61c1.134-.373 2.057-1.126 2.606-2.204.55-1.078.616-2.267.252-3.404-.365-1.136-1.108-2.058-2.179-2.604-1.07-.545-2.253-.605-3.387-.232-4.697 1.546-9.913 1.198-14.3-1.038-4.39-2.236-7.791-6.143-9.247-10.96-3.177-9.904 2.262-20.58 12.088-23.723 4.697-1.546 9.913-1.197 14.3 1.039 2.249 1.145 4.276 2.721 5.763 4.566-2.259-.065-4.32 1.601-4.668 3.87z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}

export default SvgRedialButton;